import styled from 'styled-components'
import { ProductCol, ProductTotal } from '../CartProduct/index.styled'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const ProductCouponCol = styled(ProductCol)`
	color: ${colorTheme.cart.cartGiftCoupon.text};
`
ProductCouponCol.displayName = 'ProductCouponCol'

export const ProductCouponName = styled(ProductCol)`
	font-weight: 600;
	flex-direction: column;
	align-items: start;
	color: ${colorTheme.cart.cartGiftCoupon.text};
`
ProductCouponName.displayName = 'ProductCouponName'

export const ProductCode = styled.div`
	color: ${colorTheme.cart.cartGiftCoupon.text};
	font-weight: 500;
	white-space: nowrap;
`
ProductCode.displayName = 'ProductCode'

export const ProductCouponTotal = styled(ProductTotal)`
	color: ${colorTheme.cart.cartGiftCoupon.text};
`
ProductCouponTotal.displayName = 'ProductCouponTotal'

export const MinusButtonWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: end;

	> button {
		width: 2.81em;
		height: 2.81em;
	}
`
MinusButtonWrap.displayName = 'MinusButtonWrap'

